export default {
  resource: "admin.adminPlugins",
  map() {
    this.route("flexible-rate-limits");
  }
};